import { gql } from "@grandvisionhq/graphql";
const BillingAddressFragment = gql`
  fragment BillingAddressFragment on CustomerAddress {
    additionalAddressInfo
    additionalStreetInfo
    city
    company
    country
    firstName
    lastName
    middleName
    salutation
    postalCode
    prefix
    region
    streetName
    streetNumber
  }
`;
export {
  BillingAddressFragment as default
};
//# sourceMappingURL=billing-address.js.map
